/**
 * useAutoSave Hook
 *
 * Automatically saves form data at specified intervals
 */

import { useEffect, useRef } from 'react';
import api from '../services/api';

const useAutoSave = (requestId, answers, interval = 30000, enabled = true) => {
  const previousAnswers = useRef(answers);

  useEffect(() => {
    if (!requestId || !enabled) {
      return;
    }

    const hasChanges = JSON.stringify(previousAnswers.current) !== JSON.stringify(answers);

    if (!hasChanges) {
      return;
    }

    const timer = setTimeout(async () => {
      try {
        await api.autoSaveRequest(requestId, answers);
        previousAnswers.current = answers;
      } catch (error) {
        console.error('Auto-save failed:', error);
      }
    }, interval);

    return () => clearTimeout(timer);
  }, [requestId, answers, interval, enabled]);
};

export default useAutoSave;
